export const init = () => {
    const header = document.querySelector('.header');
    const scrollDown = 'sticky-scroll-down';
    let lastScroll = 0;

    if (header) {
      window.addEventListener("scroll", () => {
          const currentScroll = window.pageYOffset;
          if (currentScroll === 0) {
            return;
          }
          if (currentScroll > lastScroll && currentScroll > 60) {
            //! down
            header.classList.add(scrollDown);
          } else if ( currentScroll < lastScroll && header.classList.contains(scrollDown)) {
            header.classList.remove(scrollDown);
          }
          lastScroll = currentScroll;
      }, {passive: true});
    }
}